import {
  DOCUMENT,
  IMAGE_EXTENSIONS,
  VIDEO_EXTENSIONS,
  AUDIO_EXTENSIONS,
  OFFICE_EXTENSIONS,
  PDF_EXTENSIONS,
  VIDEO_TYPE,
  IMAGE_TYPE,
  PDF_TYPE,
  AUDIO_TYPE,
  OFFICE_TYPE
} from "@/modules/Document/constants/DocumentConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EmptyState from "../EmptyState/EmptyState.vue";
import Vuetify from "vuetify";

Vue.use(Vuetify);
@Component({
  name: "DocumentViewer",
  components: { EmptyState }
})
export default class DocumentViewer extends Vue {
  @Prop({ default: false })
  private dialog!: boolean;
  @Prop({ default: "" })
  private documentURL!: string;
  @Prop({ default: DOCUMENT.PROP_DEFAULT.PREV_NAME })
  private documentName!: string;
  documentType = "";
  VIDEO_TYPE = VIDEO_TYPE;
  IMAGE_TYPE = IMAGE_TYPE;
  PDF_TYPE = PDF_TYPE;
  AUDIO_TYPE = AUDIO_TYPE;
  OFFICE_TYPE = OFFICE_TYPE;
  EMPTY_STATE_HEADER = DOCUMENT.EMPTY_STATE.HEADER;
  EMPTY_STATE_PARAGRAPH = DOCUMENT.EMPTY_STATE.PARAGRAPH;

  cardClass = STYLE_CLASSES.CARD;
  btnClassPrimaryRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  async getFileType(name: string) {
    const extension = name
      .split(".")
      .pop()
      ?.toLowerCase();
    if (!extension) return "";
    if (IMAGE_EXTENSIONS.includes(extension)) return IMAGE_TYPE;
    if (VIDEO_EXTENSIONS.includes(extension)) return VIDEO_TYPE;
    if (PDF_EXTENSIONS.includes(extension)) return PDF_TYPE;
    if (AUDIO_EXTENSIONS.includes(extension)) return AUDIO_TYPE;
    if (OFFICE_EXTENSIONS.includes(extension)) return OFFICE_TYPE;
    return extension;
  }

  @Watch("documentName")
  async onDocumentNameChange() {
    this.documentType = await this.getFileType(this.documentName);
  }

  closePreview() {
    this.$emit(DOCUMENT.EVENT.CLOSE_PREVIEW);
  }
}
